import { Icon, type IconName } from '@/components/common/Icon';
import { Card } from '@/components/ui/card';

interface MetricTileProps {
  iconName: IconName;
  label: string;
  value: string;
  subLabel: string;
}

export function MetricTile({ iconName, label, value, subLabel }: MetricTileProps) {
  return (
    <Card>
      <div className="flex items-center gap-2 mb-2">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name={iconName} />
        </span>
        <div className="text-xs font-semibold text-zoomuted">{label}</div>
      </div>
      <div className="text-3xl font-extrabold text-zooindigo">{value}</div>
      <div className="text-[11px] text-zoomuted mt-1">{subLabel}</div>
    </Card>
  );
}
